<template>
  <cms-modal2 unique="crew-experience-modal" title="Crew Experience Summary"
     size="md"
  >
    <div class="mb-2 d-flex justify-content-end align-items-center">
      <button class="btn btn-xs btn-primary" @click="exportSummaryExperience">
        <i class="fa fa-file-excel-o" aria-hidden="true"></i>
        Generate Excel Report
      </button>
    </div>
    <table class="w-100 table table-sm table-boder">
      <thead>
        <tr>
          <th>Rank/s</th>
          <th class="text-center">Year/s</th>
          <th class="text-center">Month/s</th>
          <th class="text-center">Day/s</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="rank in per_rank" :key="rank.rank_id">
          <td>{{ rank.rank.toUpperCase() }}</td>
          <td class="text-center">{{ rank.duration_experience.years }}</td>
          <td class="text-center">{{ rank.duration_experience.months }}</td>
          <td class="text-center">{{ rank.duration_experience.days }}</td>
        </tr>
        <tr>
          <td class="font-weight-bolder" style="border-top: 2px solid black">TOTAL EXPERIENCE</td>
          <td class="text-center font-weight-bolder" style="border-top: 2px solid black" >{{ overall.years }}</td>
          <td class="text-center font-weight-bolder" style="border-top: 2px solid black">{{ overall.months }}</td>
          <td class="text-center font-weight-bolder" style="border-top: 2px solid black">{{ overall.days }}</td>
        </tr>
      </tbody>
    </table>
  </cms-modal2>
</template>

<script>

import {mapActions, mapGetters} from 'vuex';
import {CrewActivityService} from "@/services/CrewActivityService";
import {vueAppMixin} from "@/mixins/vueAppMixin";
import {formMixin} from "@/mixins/formMixin";
import {dataMixin} from "@/mixins/dataMixin";
import {gateMixin} from "@/mixins/gateMixin";
import CmsModal2 from "@/components/elements/CmsModal2";

export default {
  name: "CrewActivityExperienceModal",
  components: {
    CmsModal2
  },
  data() {
    return {
      per_rank: [],
      overall: {years: 0, months: 0, days: 0}
    }
  },

  methods: {
    clearData() {
      this.per_rank = [];
      this.overall = {
        years: 0,
        months: 0,
        days: 0
      };
    },

    async querySummaryExperience() {
      let result = await CrewActivityService.getTotalSailingRankExperience({
        crew_id: this.crew.id
      });

      this.per_rank = result.per_rank;
      this.overall = result.overall;
    },

    async exportSummaryExperience() {
      const crew_name = this.crew.last_name + "_" + this.crew.first_name + " " + this.crew.middle_name;
      await CrewActivityService.exportTotalSailingRankExperience({
        crew_id: this.crew.id,
        crew_name: crew_name
      });
    }
  },

  computed: {
    ...mapGetters([
      "crew"
    ])
  },

  mounted() {
    this.querySummaryExperience();
  }

}
</script>

<style scoped>
.col-date {
  width: 100px !important;
}

.modal-lg, .modal-xl {
  max-width: 1150px;
}

@media print {
  .hideOnPrint {
    display: none;
  }
}
</style>
